import {
  Component,
  ElementRef,
  HostListener,
  OnInit,
  Output,
  Renderer2,
  ViewChild,
  ViewChildren,
  EventEmitter,
  AfterViewInit,
  DoCheck, Input, TemplateRef, forwardRef
} from "@angular/core";
import { ContentChild } from "@angular/core";
import { Subject } from "rxjs";
import { NG_VALUE_ACCESSOR, FormControl } from "@angular/forms";
import { ParameterService } from "../../utils/services/parameter.service";
import { distinctUntilChanged, debounceTime } from "rxjs/operators";

@Component({
  selector: "app-city-dropdown",
  templateUrl: "./city-dropdown.component.html",
  styleUrls: ["./city-dropdown.component.scss"],
  providers: [
    {
      provide: NG_VALUE_ACCESSOR,
      useExisting: forwardRef(() => CityDropdownComponent),
      multi: true
    }
  ]
})
export class CityDropdownComponent implements OnInit, AfterViewInit, DoCheck {

  @ViewChild("dropdownButton") dropdownButton: ElementRef;
  @Input() dropdownItemTemplate: TemplateRef<any>;
  @Input() dropdownButtonTemplate: TemplateRef<any>;
  @ViewChild("searchInput") searchInput;
  @ViewChild("dropdownMenu") dropdownMenu;
  @ViewChildren("dropdownItem") dropdownItems;
  @Input() singleSelect: boolean = false;
  @Input() searchable: boolean = true;
  @Input() setTheOnlyItemAsSelected: boolean = true;
  @Input() isClearable = true;
  private selectedIndex = 0;
  public visibleCount = 0;
  public searchInputControl = new FormControl();
  public dataList: Array<any>;
  public selectedDataList: Array<any> = [];

  @ContentChild("myelement") children;
  private keyEventSubject: Subject<string> = new Subject();

  @Input()
  selectedCities: Array<any> = [];
  @Output()
  onCitySelected: EventEmitter<any> = new EventEmitter<any>();
  @Input()
  zone;
  @Input()
  sourceType = 'FLIGHT'; // FLIGHT, HOTEL
  public searchParams: URLSearchParams = new URLSearchParams();
  public limit = 10;
  public propagateChange = (_: any) => { };


  @HostListener("window:click", ["$event"])
  clickHandler(event) {
    if (!(this.elementRef.nativeElement.contains(event.target))) {
      this.hideDropDown();
    }
  }


  constructor(private renderer: Renderer2, private parameterService: ParameterService,
    private elementRef: ElementRef) {
  }

  ngOnInit() {
    this.keyEventSubject.debounceTime(300).subscribe(event => {
      this.handleKeyDown(event);
    });

    this.searchParams.set('limit', this.limit.toString());
    this.searchParams.set('offset', '0');
    this.searchParams.set('sortBy', 'name');
    this.searchParams.set('sortType', 'ASC');
    this.searchParams.set("type_Eq", "city");
    this.searchInputControl.valueChanges.pipe(
      debounceTime(200),
      distinctUntilChanged()
    ).subscribe(value => {
      if (value) {
        if (value.length > 0) {
          this.onSearchTextChanged(value);
        } else {
          this.onSearchTextChanged(null);
        }
      } else {
        this.onSearchTextChanged(null);
      }
    })
    this.fetchCities();
  }

  fetchCities() {
    this.parameterService.getCities(this.searchParams).subscribe(res => {
      this.setMenuDataForInitialize(res.data);
    }, err => {
      this.setMenuDataForInitialize([]);
    })
  }


  ngAfterViewInit() {

  }

  ngDoCheck() {
    if (this.dropdownButton && this.dropdownButton.nativeElement && this.dropdownButton.nativeElement.querySelectorAll(".pinned")[0]) {
      this.visibleCount = Math.floor(this.dropdownButton.nativeElement.offsetWidth / this.dropdownButton.nativeElement.querySelectorAll(".pinned")[0].offsetWidth) - 2;
    }
  }

  setSelectedData(selectedDataList: Array<any>) {
    if (Array.isArray(selectedDataList)) {
      this.selectedDataList = selectedDataList;
    } else {
      this.selectedDataList = [];
    }
  }

  setMenuDataForInitialize(dataList: Array<any>): void {
    if (Array.isArray(dataList)) {
      this.dataList = dataList;
      if (this.setTheOnlyItemAsSelected && (this.selectedDataList && this.selectedDataList.length == 0) && (this.dataList && this.dataList.length == 1)) {
        this.setSelectedData([...this.dataList]);
      }
    } else {
      this.dataList = [];
    }
  }

  setMenuDataForLoadMore(dataList: Array<any>): void {
    if (Array.isArray(dataList)) {
      this.dataList = dataList;
    } else {
      this.dataList = [];
    }
  }

  addMenuData(data) {
    this.dataList.push(data);
  }

  onDataPicked(data: any) {
    if (data) {

      if (this.singleSelect) {
        if (this.selectedDataList.length == 0) {
          this.selectedDataList[0] = data;
        } else {
          if (data['id'] === this.selectedDataList[0]['id']) {
            if (this.isClearable && this.selectedDataList.length > 0)
              this.selectedDataList.splice(0, 1);
          } else {
            this.selectedDataList[0] = data;
          }
        }

        this.onCitySelected.emit(this.selectedDataList);
        this.propagateChange(this.selectedDataList);
        this.hideDropDown();
      } else {
        var selectedIndex = this.selectedDataList.findIndex((element) => element['id'] === data['id']);
        if (selectedIndex > -1) {
          this.selectedDataList.splice(selectedIndex, 1);
        } else {
          this.selectedDataList.push(data);
        }
        this.onCitySelected.emit(this.selectedDataList);
        this.propagateChange(this.selectedDataList);
      }
    }

  }

  showDropDown() {
    this.renderer.addClass(this.dropdownMenu.nativeElement, "show");
    if (this.dropdownItems.toArray()[this.selectedIndex]) {
      this.dropdownItems.toArray()[this.selectedIndex].nativeElement.focus();
    }
    if (this.searchable) {
      this.searchInput.nativeElement.click();
      this.searchInput.nativeElement.focus();
    }

  }

  hideDropDown() {
    this.renderer.removeClass(this.dropdownMenu.nativeElement, "show");
  }

  toggleDropdownMenu() {
    if (this.dropdownMenu.nativeElement.classList.contains("show")) {
      this.hideDropDown();
    }
    else {
      this.renderer.removeClass(this.dropdownMenu.nativeElement, "hide");
      this.showDropDown();
    }
  }

  keyDown(event) {
    //event.preventDefault();
    //40 down
    //38 UP
    //27 Escape
    //13 Enter
    //this.logger.log(event);
    this.keyEventSubject.next(event);
  }

  handleKeyDown(event) {
    switch (event.keyCode) {
      case 40:
        if (this.selectedIndex > this.dataList.length - 1) {
          this.selectedIndex = this.dataList.length - 1;
          if (this.dropdownItems.toArray()[this.selectedIndex]) {
            this.dropdownItems.toArray()[this.selectedIndex].nativeElement.focus();
          }
        }
        else {
          this.selectedIndex++;
          if (this.dropdownItems.toArray()[this.selectedIndex]) {
            this.dropdownItems.toArray()[this.selectedIndex].nativeElement.focus();
          }
        }
        break;
      case 38:
        if (this.selectedIndex < 1) {
          this.selectedIndex = 0;
          if (this.dropdownItems.toArray()[this.selectedIndex]) {
            this.dropdownItems.toArray()[this.selectedIndex].nativeElement.focus();
          }
        }
        else {
          this.selectedIndex--;
          if (this.dropdownItems.toArray()[this.selectedIndex]) {
            this.dropdownItems.toArray()[this.selectedIndex].nativeElement.focus();
          }
        }
        break;
      case 27:
        this.hideDropDown();
        break;
      case 13:
        this.onDataPicked(this.dataList[this.selectedIndex]);
        break;
    }
  }

  onScroll() {
    this.searchParams.set('offset', this.dataList.length.toString());
    this.parameterService.getCities(this.searchParams).subscribe(
      response => {
        response.data.forEach(item => {
          this.dataList.push(item)
        });
      },
      error => { }
    );
  }



  isItemSelected(item: any) {
    if (this.selectedDataList) {
      return this.selectedDataList.findIndex((element) => element['id'] === item['id']) > -1 ? true : false;
    }
    return false;
  }

  public colorArray = [
    "#85bb65",
    "#ee4f4f",
    "#eece4f",
    "#eeae4f",
    "#168eea",
    "#161eea",
    "#bb4f4f"
  ];

  getColor(data: any) {
    return this.colorArray[<number>(data['id'] % 8)];
  }

  isFunction(item) {
    if (typeof item === "function") {
      return true;
    }
    return false;
  }


  writeValue(value: any) {
    this.setSelectedCities(value);
  }

  registerOnChange(fn) {
    this.propagateChange = fn;
  }

  registerOnTouched() { }

  onDataSelected(selectedCities: Array<any>) {
    this.onCitySelected.emit(selectedCities);
    this.propagateChange(selectedCities);
  }

  setSelectedCities(selectedCities: Array<any>) {
    if (
      Array.isArray(selectedCities) &&
      selectedCities &&
      selectedCities.length > 0
    ) {
      let searchParams: URLSearchParams = new URLSearchParams();
      searchParams.set('id_In', this.getCityIDs(selectedCities).toString());
      this.parameterService.getCities(searchParams).subscribe(
        response => {
          if (Array.isArray(response.data)) {
            this.selectedDataList = response.data;
          } else {
            this.selectedDataList = [];
          }
        },
        error => {
          this.selectedDataList = [];
        }
      );
    } else {
      this.selectedDataList = [];
    }
  }

  getCityCodes(cityList: Array<any>) {
    let codes = [];
    cityList.forEach(city => {
      codes.push(city.cityCode);
    });
    return codes;
  }

  getCityIDs(cityList: Array<any>) {
    let IDs = [];
    cityList.forEach(city => {
      IDs.push(city.id);
    });
    return IDs;
  }



  onSearchTextChanged(searchText) {

    this.searchParams = new URLSearchParams();
    this.searchParams.set('limit', this.limit.toString());
    this.searchParams.set('offset', 0 + '');
    this.searchParams.set('sortBy', 'name');
    this.searchParams.set('sortType', 'ASC');
    this.searchParams.set("type_Eq", "city");

    if (searchText) {
      this.searchParams.set(
        'name_Like',
        searchText
      );
    }
    // this.parameterHttpService.getCities(this.searchParams)
    this.parameterService.getCities(this.searchParams).subscribe(
      response => {
        if (Array.isArray(response.data)) {
          this.dataList = response.data;
        } else {
          this.dataList = [];
        }
      },
      error => {
        this.dataList = [];
      }
    );
  }

}



// WEBPACK FOOTER //
// /var/www/bizisystem-frontend/src/src/app/shared/city-dropdown/city-dropdown.component.ts